export default function () {
  return {
    profile: {},
    authentications: {
      token_api: '',
      social: '',
      tokenSocial: '',
      name: '',
      email: ''
    },
    isAuthenticated: false,
    decrypted: false
  }
}
